// Reference-markup helpers shared by the Cricket Match 20-20 / Casino Meter / 1 Card Meter /
// 20-20 D T L / Bollywood Casino pages (live + virtual).
import { useState } from "react";
import { formatBook } from "../../../utils/formatOdds";

export const IMG = `${import.meta.env.BASE_URL}img`;
export const REMARK_ICON = `${import.meta.env.BASE_URL}assets/img/icons/remark.png`;

// Reference v-kvalmin / v-kvalmax: 1000 → "1K", 100000 → "1L" (2 decimals, trailing zeros dropped)
export function formatRangeVal(val) {
  const n = Number(val);
  if (val == null || val === "" || Number.isNaN(n)) return "";
  if (n >= 100000) return `${parseFloat((n / 100000).toFixed(2))}L`;
  if (n >= 1000) return `${parseFloat((n / 1000).toFixed(2))}K`;
  return String(parseFloat(n.toFixed(2)));
}

// Downline exposure for a market (by nat), 0 when none
export function getExposure(exposures, nat) {
  if (!nat || !exposures) return 0;
  const v = exposures[nat] ?? exposures[String(nat).toLowerCase()];
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
}

// Reference v-casinofancybook / v-casinobook: amount > 0 → book-green, otherwise book-red
export const bookClass = (amt) => (amt > 0 ? "book-green" : "book-red");
// Book figure: en-IN, decimals only when present (utils/formatOdds formatBook)
export const bookText = formatBook;

export const isSuspended = (item) => String(item?.gstatus || "").toUpperCase() !== "OPEN";

/**
 * Bootstrap-collapse range popup toggled by an (i) icon, like the reference
 * (`<i data-toggle="collapse" data-target="#id" class="fas fa-info-circle [collapsed]">` +
 * `<div id class="collapse icon-range[ show]">R:<span>min</span>-<span>max</span></div>`).
 */
export function useRangeToggle() {
  const [open, setOpen] = useState({});
  const toggle = (id) => setOpen((s) => ({ ...s, [id]: !s[id] }));
  return [open, toggle];
}


/**
 * Reference LastResultsSection text: every branch is a conditional text joined by " "
 * (e.g. Casino Meter win 2 → " H "), so the spacing matches the reference exactly.
 */
export const joinSlots = (win, slots) => slots.map(([w, label]) => (String(w) === win ? label : "")).join(" ");
